var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "studio-page-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("ADMINISTRATOR")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex m__t--45" },
            [
              _vm._l(_vm.tabMenu, function(tab, index) {
                return [
                  tab.show
                    ? _c(
                        "div",
                        {
                          key: tab.label,
                          class: [
                            { "m__r--35": index < _vm.tabMenu.length - 1 },
                            tab.active
                              ? "tab-experience-manager-active"
                              : "tab-experience-manager"
                          ],
                          on: {
                            click: function($event) {
                              _vm.$router.replace(tab.url)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(tab.label) + "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "studio-page-administrator-content" }, [
        _c("div", { staticClass: "wrap-company-setting" }, [
          _c(
            "div",
            { staticClass: "side-menu" },
            _vm._l(_vm.sideMenu, function(menu) {
              return _c(
                "div",
                {
                  key: menu.id,
                  staticClass: "side-menu-list",
                  class: { active: _vm.sideMenuActive === menu.id },
                  on: {
                    click: function($event) {
                      _vm.sideMenuActive = menu.id
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(menu.text) + "\n        ")]
              )
            })
          ),
          _vm._v(" "),
          _c("div", { staticClass: "menu-content" }, [
            _vm.sideMenuActive === "general"
              ? _c("div", [
                  _vm.useConfigAdvanceExportAndImport
                    ? _c("div", { staticClass: "card-layer" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _c("h4", [_vm._v("Advance Import and Export")]),
                            _vm._v(" "),
                            _c("j-toggle", {
                              staticClass: "fix-position-toggle",
                              model: {
                                value: _vm.dataSetup.advance_report,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "advance_report", $$v)
                                },
                                expression: "dataSetup.advance_report"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "description mb-0" }, [
                          _vm._v(
                            "\n              Enable configuration for advanced import and export views in the Experience Manager module.\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(0)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-layer" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between"
                      },
                      [
                        _c("h4", [_vm._v("Move Table")]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          staticClass: "fix-position-toggle",
                          model: {
                            value:
                              _vm.dataSetupV2.data_manager_enable_move_table,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetupV2,
                                "data_manager_enable_move_table",
                                $$v
                              )
                            },
                            expression:
                              "dataSetupV2.data_manager_enable_move_table"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description mb-0" }, [
                      _vm._v(
                        "\n              Enable configuration for allows moving table between table groups\n            "
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.sideMenuActive === "security"
              ? _c("div", [
                  _c("div", { staticClass: "card-layer" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        "\n              Time period to define login session expires\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-component-wrap" },
                      [
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Period ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.loginSessionOptions,
                                "error-required": false,
                                placeholder: "Select Period"
                              },
                              model: {
                                value: _vm.dataSetup.token_expired,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "token_expired", $$v)
                                },
                                expression: "dataSetup.token_expired"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "ml-0",
                            on: { click: _vm.updateDataSettings }
                          },
                          [_vm._v("\n                Update\n              ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(2)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-layer" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        "\n              Time period to define login session expires\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "card-component-wrap" },
                      [
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Period ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.refreshSessionOptions,
                                "error-required": false,
                                placeholder: "Select Period"
                              },
                              model: {
                                value: _vm.dataSetup.refresh_token_expired,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "refresh_token_expired",
                                    $$v
                                  )
                                },
                                expression: "dataSetup.refresh_token_expired"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "ml-0",
                            on: { click: _vm.updateDataSettings }
                          },
                          [_vm._v("\n                Update\n              ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(4)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-layer" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between"
                      },
                      [
                        _c("h4", [_vm._v("Force Change Password")]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          staticClass: "fix-position-toggle",
                          model: {
                            value: _vm.dataSetup.force_change_password,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetup,
                                "force_change_password",
                                $$v
                              )
                            },
                            expression: "dataSetup.force_change_password"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description mb-0" }, [
                      _vm._v(
                        "\n              Force new user to change their password\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-layer" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between"
                      },
                      [
                        _c("h4", [_vm._v("Password History Validation")]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          staticClass: "fix-position-toggle",
                          model: {
                            value: _vm.dataSetup.history_password_validation,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetup,
                                "history_password_validation",
                                $$v
                              )
                            },
                            expression: "dataSetup.history_password_validation"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description mb-0" }, [
                      _vm._v(
                        "\n              Enable validation to disallow user from using previous password\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-layer" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-between"
                      },
                      [
                        _c("h4", [_vm._v("Suspected Login Validation")]),
                        _vm._v(" "),
                        _c("j-toggle", {
                          staticClass: "fix-position-toggle",
                          model: {
                            value: _vm.dataSetup.suspected_login_validation,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dataSetup,
                                "suspected_login_validation",
                                $$v
                              )
                            },
                            expression: "dataSetup.suspected_login_validation"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "description" }, [
                      _vm._v(
                        "\n              Enable validation to handle suspected login\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.dataSetup.suspected_login_validation
                      ? _c(
                          "div",
                          { staticClass: "card-component-wrap" },
                          [
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup
                                      .suspected_login_validation_config
                                      .max_login_trial.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Maximum Login Trial ")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: {
                                    "error-required": false,
                                    type: "number",
                                    placeholder: "Input Value"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup
                                        .suspected_login_validation_config
                                        .max_login_trial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup
                                          .suspected_login_validation_config,
                                        "max_login_trial",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.suspected_login_validation_config.max_login_trial"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.suspectedLoginValidationAction.$error
                                }
                              },
                              [
                                _c("label", [_vm._v(" Validation do ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.suspectedLoginOptions,
                                    "error-required": false,
                                    placeholder: "Select Validation"
                                  },
                                  model: {
                                    value: _vm.suspectedLoginValidationAction,
                                    callback: function($$v) {
                                      _vm.suspectedLoginValidationAction = $$v
                                    },
                                    expression: "suspectedLoginValidationAction"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.suspectedLoginValidationAction ===
                            "suspend_user"
                              ? _c(
                                  "b-form",
                                  {
                                    class: {
                                      "error-input":
                                        _vm.$v.dataSetup
                                          .suspected_login_validation_config
                                          .suspend_period.$error
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(" Suspension Period ")
                                    ]),
                                    _vm._v(" "),
                                    _c("j-single-select", {
                                      attrs: {
                                        options: _vm.suspendPeriodOptions,
                                        "error-required": false,
                                        placeholder: "Select Period"
                                      },
                                      model: {
                                        value:
                                          _vm.dataSetup
                                            .suspected_login_validation_config
                                            .suspend_period,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.dataSetup
                                              .suspected_login_validation_config,
                                            "suspend_period",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataSetup.suspected_login_validation_config.suspend_period"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "ml-0",
                                on: { click: _vm.updateDataSettings }
                              },
                              [
                                _vm._v(
                                  "\n                Update\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.suspectedLoginValidationAction === "block_user"
                      ? _c("div", { staticClass: "information-session" }, [
                          _c("img", {
                            attrs: { src: require("@/assets/icon/info.svg") }
                          }),
                          _vm._v(" "),
                          _vm._m(5)
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.useConfigConcurrentLogin
                    ? _c("div", { staticClass: "card-layer" }, [
                        _c("h4", [
                          _vm._v("Concurrent Login Session Device Restrictions")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "description" }, [
                          _vm._v(
                            "\n              Limit or control the number of devices or sessions a user can log in to simultaneously\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-component-wrap" },
                          [
                            _c(
                              "b-form",
                              [
                                _c("label", [_vm._v(" Restriction options ")]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.concurrentLoginOptions,
                                    "error-required": false,
                                    placeholder: "Select restriction"
                                  },
                                  model: {
                                    value: _vm.dataSetupV2.concurrent_login,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetupV2,
                                        "concurrent_login",
                                        $$v
                                      )
                                    },
                                    expression: "dataSetupV2.concurrent_login"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "ml-0",
                                on: { click: _vm.updateConcurrentDevice }
                              },
                              [
                                _vm._v(
                                  "\n                Update\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalConfirmation",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("j-popup-confirmation", {
            attrs: { message: _vm.messageConcurrent },
            on: {
              close: _vm.closePopupConfirmation,
              confirm: _vm.updateDataSettingsV2
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "warning-information d-flex align-items-start" },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/icon/info-circle.svg"),
            alt: "warning-icon"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("p", { staticClass: "title-warning" }, [_vm._v("Information")]),
          _vm._v(" "),
          _c("p", { staticClass: "desc-warning" }, [
            _vm._v(
              "\n                  Please contact your Administrator to ensure the infrastructure supports this configuration.\n                "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [_c("h4", [_vm._v("Periodic Login Session")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-session" }, [
      _c("img", { attrs: { src: require("@/assets/icon/info.svg") } }),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("Information")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Changing the Period will affect the authorization to access Officeless Applications."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [_c("h4", [_vm._v("Periodic Refresh Session")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information-session" }, [
      _c("img", { attrs: { src: require("@/assets/icon/info.svg") } }),
      _vm._v(" "),
      _c("div", [
        _c("p", [_vm._v("Information")]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Changing the Period will affect the authorization to access Officeless Applications."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [_vm._v("Information")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "A blocked user can be activated by changing the Active status in the user's Administrator settings.."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77799c3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77799c3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/jCompanySetting.vue
// module id = null
// module chunks = 